export const stateName = 'auth';
export let AuthView;

(function (AuthView) {
  AuthView["SelectTypeRegister"] = "select_type_register";
  AuthView["SelectTypeLogin"] = "select_type_login";
  AuthView["EmailLogin"] = "email_login";
  AuthView["EmailRegister"] = "email_register";
  AuthView["ResetPassword"] = "reset_password";
})(AuthView || (AuthView = {}));

export let AuthExternalRegisterView;

(function (AuthExternalRegisterView) {
  AuthExternalRegisterView["FacebookRegister"] = "facebook_register";
  AuthExternalRegisterView["GoogleRegister"] = "google_register";
  AuthExternalRegisterView["AppleRegister"] = "apple_register";
  AuthExternalRegisterView["PasswordVerification"] = "password_verification";
})(AuthExternalRegisterView || (AuthExternalRegisterView = {}));

export let NewsletterSubscription;

(function (NewsletterSubscription) {
  NewsletterSubscription["OptIn"] = "opt_in";
  NewsletterSubscription["OptOut"] = "opt_out";
  NewsletterSubscription["WithTerms"] = "with_terms";
})(NewsletterSubscription || (NewsletterSubscription = {}));